import { useQuery } from 'react-query';
import { queryAllSubscriptions } from './useAllSubscriptions.query';
import {
  QueryAllSubscriptionsResponse,
  UseAllSubscriptionsOptions,
} from './useAllSubscriptions.types';

export const ALL_SUBSCRIPTIONS_QUERY_KEY = 'ALL_SUBSCRIPTIONS';

export const useAllSubscriptions = (options?: UseAllSubscriptionsOptions) => {
  return useQuery<QueryAllSubscriptionsResponse, Error>(
    ALL_SUBSCRIPTIONS_QUERY_KEY,
    () => queryAllSubscriptions(),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
